import React from "react";
import { createContext, useContext } from "react";

import { HttpError } from "@refinedev/core";
import { IModelAlias, IDimension, IMeasure } from "@src/types/ab-testing-exploration";
import { useGetModelMember } from "@src/hooks/use-get-model-member";
type AbTestExplorationContextType = {
  isLoadingMeta: boolean;
  loadMetaError: HttpError | null;
  refreshMeta: () => void;
  availableModels: IModelAlias[];
  getAvailableDimensionsTree: ({ modelAlias }: { modelAlias: IModelAlias }) => Record<string, IDimension[]> | undefined;
  getAvailableDimensions: ({ modelAlias }: { modelAlias: IModelAlias }) => IDimension[] | undefined;
  getAvailableMeasures: ({ modelAlias }: { modelAlias: IModelAlias }) => IMeasure[] | undefined;
};
export const AbTestExplorationContext = createContext({} as AbTestExplorationContextType);

type IProps = {
  children: React.ReactNode;
};

// TODO: refactor API later
export const USER_DIMENSIONS: string[] = [
  "device_model",
  "device_category",
  "media_source",
  "country_code",
  "first_app_version",
  "last_app_version",
  "first_signal_date",
  "day0_date",
  "install_date_tzutc",
];
export const AbTestExplorationContextProvider: React.FC<IProps> = ({ children }) => {
  const {
    isLoadingMeta,
    loadMetaError,
    refreshMeta,
    availableModels: ableToExploreModels,
    getAvailableDimensionsTree,
    getAvailableDimensions,
    getAvailableMeasures,
  } = useGetModelMember();

  const values = {
    isLoadingMeta,
    loadMetaError,
    refreshMeta,
    availableModels: ableToExploreModels,
    getAvailableDimensionsTree,
    getAvailableDimensions,
    getAvailableMeasures,
  };
  return <AbTestExplorationContext.Provider value={values}>{children}</AbTestExplorationContext.Provider>;
};

export const useAbTestExplorationContext = () => useContext(AbTestExplorationContext);
